<div class="dynamicForm_alignment" [formGroup]="group">
  <div class="datetime-container" style="display: flex; gap: 8px; align-items: flex-start;">
    <mat-form-field [hideRequiredMarker]="hideRequiredMarker" style="flex: 1;">
      <mat-label><span>{{field.labelName}}</span>@if (isRequired) {
      <span>*</span>
      }<span class="font-size-small"> (MM/DD/YYYY hh:mm AM/PM)</span></mat-label>
      <input [id]="field.labelName" matInput [owlDateTime]="dt1" [formControlName]="field.labelCode"
        [min]="field.minDate" [max]="field.maxDate" [placeholder]="field.labelName"
        [required]="isRequired" (keydown)="onKeydown($event)" (focus)="resetDefaultTime()">
        <button matSuffix class="datetimebutton" [owlDateTimeTrigger]="dt1" [disabled]="isDisabled" (click)="resetDefaultTime()" type="button">
          <mat-icon>event</mat-icon>
        </button>
        <owl-date-time #dt1 [pickerType]="'both'" [hour12Timer]="true" [startAt]="group.get(field.labelCode)?.value || field.maxDate || field.minDate" pickerMode="popup"
          (afterPickerOpen)="onPickerOpen(dt1)"></owl-date-time>

        @if (!field.dateFormatError && field.maxDateTimeError) {
          <mat-error>Date and time should not be more than {{field.maxDate | date:'M/d/yyyy h:mm a'}}</mat-error>
        }
        @if (!field.dateFormatError && field.minDateTimeError) {
          <mat-error>Date and time should not be less than {{field.minDate | date:'M/d/yyyy h:mm a'}}</mat-error>
        }
        @if (group.get(field.labelCode).touched && group.get(field.labelCode).hasError(required) && !field.dateFormatError) {
          <mat-error>{{field.labelName}} is mandatory</mat-error>
        }
        @if (field.dateFormatError) {
          <mat-error>Invalid Date format</mat-error>
        }
      </mat-form-field>
    </div>
    </div>
